// src/lib/api.js
// Kald til vores egne serverfunktioner, med brugerens adgangstoken.
//
// Serverfunktionerne kræver login — kald uden gyldigt token afvises med
// 401 eller 403. Kunde-appen og admin-panelet har hver sin Supabase-klient
// (forskellig storageKey, så de ikke deler session), derfor en fabrik
// frem for et færdigt authFetch.

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} sb
 * @returns {(url: string, options?: RequestInit) => Promise<Response>}
 */
export function opretAuthFetch(sb) {
  return async function authFetch(url, options = {}) {
    const { data: { session } } = await sb.auth.getSession();
    const token = session?.access_token;
    return fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
        ...(token ? { Authorization: 'Bearer ' + token } : {}),
      },
    });
  };
}
